module.exports = __webpack_public_path__ + "static/media/white-logo-noword.d49ca2f0.svg";